/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MessageGroupDetails = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        participants: {
    type: 'array',
    contains: {
        type: 'GroupParticipants',
    },
},
        createdAt: {
    type: 'string',
    isRequired: true,
},
    },
};